// Same width as the bar's phone layout (MatchDock.scss $match-dock-phone).
// Phones get no sheets: the dock's controls follow their links instead.
const PHONE_QUERY = '(max-width: 720px)';

export function isPhoneWidth() {
	return typeof window.matchMedia === 'function' && window.matchMedia(PHONE_QUERY).matches;
}
